import { clientHttp } from 'common/http';
import {
  getBigPromotionResponseSchema,
  type GetBigPromotionApi,
} from './get-big-promotion';

export const getBigPromotion: GetBigPromotionApi = async ({
  signal,
}) => {
  const json = await clientHttp.get('/api/promotions/big-promotion', { signal }).json();
  return getBigPromotionResponseSchema.parse(json);
};
